'use strict';

var focusHelper = require('base/components/focus');

var location = window.location;

/**
 * Updates/removes discount-related price elements (.cc-price__percentage,
 * .cc-price__original, .cc-price__comparison) inside a given .price container.
 * @param {jQuery} $priceEl - the .price DOM element to update
 * @param {Object} product  - product view model from the variation response
 * @param {Object} resources - resource strings from the AJAX response
 */
function updateDiscountElements($priceEl, product, hasAdditionalPrices, additionalPricesHtml, hasPriorBestPrice, hasSellerPrice, refPriceHtml, resources, discountPercentage) {
    var $ccPrice = $priceEl.find('.cc-price');
    if (!$ccPrice.length) {
        var $outerSpan = $priceEl.children('span').first();
        if ($outerSpan.length) {
            var $salesEl = $outerSpan.find('.sales');
            if ($salesEl.length) {
                $salesEl.removeClass('sales').addClass('cc-price__sales');
                $outerSpan.replaceWith('<span class="cc-price">' + $salesEl[0].outerHTML + '</span>');
            }
        }
        $ccPrice = $priceEl.find('.cc-price');
    }
    if (!$ccPrice.length) { return; }

    $ccPrice.find('.strike-through.list').closest('del').remove();

    var $additionalPricesEl = $ccPrice.find('.cc-price__additionalPrices');
    if (hasAdditionalPrices && additionalPricesHtml) {
        if ($additionalPricesEl.length) {
            $additionalPricesEl.replaceWith(additionalPricesHtml);
        } else {
            $ccPrice.find('.cc-price__sales').after(additionalPricesHtml);
        }
    } else {
        $additionalPricesEl.remove();
    }

    var $existingRefEl = $ccPrice.find('.cc-price__best, .cc-price__comparison');
    var hasReferencePrice = hasPriorBestPrice || hasSellerPrice;

    if (hasReferencePrice && refPriceHtml) {
        if ($existingRefEl.length) {
            $existingRefEl.replaceWith(refPriceHtml);
        } else {
            $ccPrice.append(refPriceHtml);
        }
        var refBtnClass = hasPriorBestPrice ? 'cc-price__omnibus-info' : 'cc-price__seller-info';
        $ccPrice.find('.' + refBtnClass).tooltip({ html: true, container: 'body' });
    } else {
        $existingRefEl.remove();
    }

    var $percentageEl = $ccPrice.find('.cc-price__percentage, .cc-price__privilegePercentage');
    if (discountPercentage && discountPercentage.formatted) {
        var isPrivilege = ($percentageEl.length && $percentageEl.hasClass('cc-price__privilegePercentage')) ||
            !!(product.promotionPrivileges && product.promotionPrivileges.isPrivilegesPromo);
        var percentageClass = isPrivilege ? 'cc-price__percentage cc-price__privilegePercentage' : 'cc-price__percentage';
        var percentageHtml = '<span class="' + percentageClass + '"><span>-' + discountPercentage.formatted + '</span></span>';
        if ($percentageEl.length) {
            $percentageEl.replaceWith(percentageHtml);
        } else {
            $ccPrice.append(percentageHtml);
        }
    } else {
        $percentageEl.remove();
    }

    var $currentReferenceEl = $ccPrice.find('.cc-price__best, .cc-price__comparison').first();
    var $currentPercentageEl = $ccPrice.find('.cc-price__percentage, .cc-price__privilegePercentage').first();
    if ($currentReferenceEl.length && $currentPercentageEl.length) {
        $currentPercentageEl.insertAfter($currentReferenceEl);
    }
}

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;
    pid = $($el).attr('data-pid');
    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.js-productDetail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        let $attrValue;
        let $titleSelected;

        $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');
        $titleSelected = $productContainer.find('[data-attr="' + attr.id + '"] .cc-pdp__product__attribute__title');
        const $attrValueButton = $attrValue.closest('.js-variantsButton');

        if (attrValue.selected) {
            $attrValue.addClass('cc-pdp__product__variants__selected');
            $attrValueButton.addClass('cc-pdp__product__variants__selected');
            $attrValue.siblings('.cc-pdp__product__variants__assistive').text(msgs.assistiveSelectedText);
            $titleSelected.text(attrValue.displayValue);
        } else {
            $attrValue.removeClass('cc-pdp__product__variants__selected');
            $attrValueButton.removeClass('cc-pdp__product__variants__selected');
            $attrValue.siblings('.cc-pdp__product__variants__assistive').empty();
        }

        if (attrValue.url) {
            $attrValueButton.data('url', attrValue.url).attr('data-url', attrValue.url);
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    const $attr = '[data-attr="' + attr.id + '"]';
    const $titleSelected = $productContainer.find('[data-attr="' + attr.id + '"] .cc-pdp__product__attribute__title');

    attr.values.forEach(function (attrValue) {
        const $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.data('url', attrValue.url).attr('data-url', attrValue.url).removeAttr('disabled');

        if (attrValue.selected) {
            $attrValue.addClass('cc-pdp__product__variants__selected');
            $titleSelected.text(attrValue.displayValue);
        } else {
            $attrValue.removeClass('cc-pdp__product__variants__selected');
        }

        if (attrValue.selectable) {
            $attrValue.removeClass('cc-pdp__product__variants__disabled');
        } else {
            $attrValue.addClass('cc-pdp__product__variants__disabled');
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the browser URL to the currently selected product variation
 *
 * @param {string} selectedProductUrl - PDP URL for the selected variation
 */
function updateProductUrl(selectedProductUrl) {
    if (selectedProductUrl && window.history && typeof window.history.replaceState === 'function') {
        window.history.replaceState({}, document.title, selectedProductUrl);
    }
}

/**
 * Updates PDP fields that depend on the selected variant.
 * @param {Object} product - Product view model returned by variation selection
 * @param {Object} resources - Resource messages for internationalization
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateProductContent(product, resources, $productContainer, optionsHtml) {
    var brandName = product.custom?.brandInfo?.name || '';
    var priceHtml = product.price?.html || '';
    var salesPrice = product.price?.sales?.value || '';
    var salesCurrency = product.price?.sales?.currency || '';
    var mediumImages = product.images?.medium || [];
    var xsmallImages = product.images?.xsmall || [];
    var imageUrl = mediumImages[0]?.url || '';

    $('.cc-pdp__product__name, .cc-stickyBar__productName').text(product.productName);

    if (brandName) {
        $('.cc-pdp__product__brand').text(brandName);
    }

    // Update product tag and tag color
    var $ratingsContainer = $('.cc-pdp__product__ratings');
    var $productTag = $ratingsContainer.find('.cc-pdp__product__tag');

    if (product.custom?.tag) {
        if (!$productTag.length) {
            $productTag = $('<p class="cc-pdp__product__tag cc-pdp__product__text"></p>');
            $ratingsContainer.prepend($productTag);
        }

        $productTag.html(product.custom.tag);

        if (product.custom.tagColor) {
            $productTag.attr('style', '--tag-color: ' + product.custom.tagColor);
        } else {
            $productTag.removeAttr('style');
        }
    } else if ($productTag.length) {
        $productTag.remove();
    }

    updateRegularDeliverySection(product, $productContainer, optionsHtml);

    var $rdContainer = $('.js-regularDelivery').first();
    var isRDSelected = false;
    if ($rdContainer.length) {
        var selectedRDValueId = $rdContainer.find('.js-purchaseType:checked').data('value-id');
        var defaultRDValueId = $rdContainer.data('default-value-id');
        isRDSelected = selectedRDValueId && defaultRDValueId && selectedRDValueId !== defaultRDValueId;
    }

    var showPrice = !product.proDisplay || product.proDisplay.showPrice !== false;

    // Check if product has a valid price value, not just priceHtml
    var hasValidPrice = product.price?.sales?.value != null;

    if (showPrice && hasValidPrice && priceHtml) {
        var pricePerKilo = product.pricePerKilo && (isRDSelected
            ? product.pricePerKilo.regularDeliveryValueMoney : product.pricePerKilo.valueMoney);
        var pricePerCapsule = product.pricePerCapsule && (isRDSelected
            ? product.pricePerCapsule.regularDeliveryValueMoney : product.pricePerCapsule.valueMoney);
        var pricePerLiter = product.pricePerLiter && (isRDSelected
            ? product.pricePerLiter.regularDeliveryValueMoney : product.pricePerLiter.valueMoney);

        var hasAdditionalPrices = pricePerKilo || pricePerCapsule || pricePerLiter;
        var additionalPricesHtml = '';

        if (hasAdditionalPrices && resources) {
            additionalPricesHtml = '<div class="cc-price__additionalPrices">';

            if (resources.label_explanation) {
                additionalPricesHtml += resources.label_explanation + ' ';
            }

            var priceItems = [
                { value: pricePerKilo, label: resources.label_kilos || 'kg' },
                { value: pricePerCapsule, label: resources.label_cup || 'cup' },
                { value: pricePerLiter, label: resources.label_liter || 'L' }
            ];

            priceItems.forEach(function (item) {
                if (item.value) {
                    additionalPricesHtml += '<span class="cc-pdp__product__additionalPrice">' + item.value + ' / ' + item.label + '</span>';
                }
            });

            additionalPricesHtml += '</div>';
        }

        var hasPriorBestPrice = !isRDSelected && !!(product.priorBestPrice && product.priorBestPrice.formatted);
        var hasSellerPrice = isRDSelected
            ? !!(product.regularDeliveryDiscountPercentage && product.regularDeliveryDiscountPercentage.value > 0 && product.price.sales.formatted)
            : !hasPriorBestPrice && !!(product.sellerPrice && product.sellerPrice.formatted);
        var referencePrice = isRDSelected
            ? (hasSellerPrice ? product.price.sales : null)
            : (hasPriorBestPrice ? product.priorBestPrice : (hasSellerPrice ? product.sellerPrice : null));
        var refPriceHtml = '';
        var infoIconUrl = ($('.cc-icon use').first().attr('xlink:href') || '').replace(/#.*$/, '#icon-info-circle');

        if (referencePrice && resources) {
            var refLabel = hasPriorBestPrice
                ? (resources.label_older_price || '')
                : (resources.label_comparison_price || '');
            var refTooltip = hasPriorBestPrice
                ? (resources.label_omnibus_tooltip || '')
                : (resources.label_comparison_tooltip || '');
            var refBtnClass = hasPriorBestPrice ? 'cc-price__omnibus-info' : 'cc-price__seller-info';
            var refDelClass = hasPriorBestPrice ? 'cc-price__original cc-price__best' : 'cc-price__original cc-price__comparison';
            var refBtn = refTooltip
                ? '<button type="button" class="cc-link ' + refBtnClass + '" data-toggle="tooltip" data-placement="top" title="' + refTooltip + '">'
                + '<span class="cc-icon cc-icon--icon-info-circle" role="presentation" aria-hidden="true" focusable="false">'
                + '<svg class="cc-svg cc-svg--xsmall" aria-hidden="true" focusable="false">' +
                '<use xlink:href="' + infoIconUrl + '"></use>' +
                '</svg>' +
                '</span>' +
                '</button>'
                : '';
            refPriceHtml = '<del class="' + refDelClass + '">'
                + (refLabel ? '<p class="cc-text-xs cc-price__original__label">' + refLabel + '</p>' : '')
                + '<span class="value cc-line-through" content="' + (referencePrice.decimalPrice || '') + '">' + referencePrice.formatted + '</span>'
                + refBtn
                + '</del>';
        }

        var $pdpPrices = $('.cc-pdp__product__prices');

        // Create price container if it doesn't exist
        if (!$pdpPrices.length) {
            $('.cc-pdp__product__pricingAndPromotions').prepend('<div class="cc-pdp__product__prices"></div>');
            $pdpPrices = $('.cc-pdp__product__prices');
        }

        // Update main price
        var $priceEl = $pdpPrices.find('.price');
        if ($priceEl.length) {
            $priceEl.replaceWith(priceHtml);
        } else {
            $pdpPrices.html(priceHtml);
        }

        var activeDiscountPercentage = product.discountPercentage;
        if (isRDSelected) {
            activeDiscountPercentage = product.regularDeliveryDiscountPercentage &&
                product.regularDeliveryDiscountPercentage.value > 0
                ? product.regularDeliveryDiscountPercentage
                : null;
        }

        // Update all discount-related elements and additional prices inside .cc-price
        updateDiscountElements(
            $pdpPrices.find('.price'),
            product,
            hasAdditionalPrices,
            additionalPricesHtml,
            hasPriorBestPrice,
            hasSellerPrice,
            refPriceHtml,
            resources,
            activeDiscountPercentage
        );

        var $stickyPrices = $('.cc-stickyBar__prices');

        // Create sticky price container if it doesn't exist
        if (!$stickyPrices.length) {
            $('.cc-stickyBar__actions').prepend('<div class="cc-stickyBar__prices"></div>');
            $stickyPrices = $('.cc-stickyBar__prices');
        }

        // Update sticky bar price
        var $stickyPriceEl = $stickyPrices.find('.price');
        if ($stickyPriceEl.length) {
            $stickyPriceEl.replaceWith(priceHtml);
        } else {
            $stickyPrices.html(priceHtml);
        }

        // Update all discount-related elements and additional prices in sticky bar
        updateDiscountElements(
            $stickyPrices.find('.price'),
            product,
            hasAdditionalPrices,
            additionalPricesHtml,
            hasPriorBestPrice,
            hasSellerPrice,
            refPriceHtml,
            resources,
            activeDiscountPercentage
        );

        // Show price elements
        $pdpPrices.removeClass('d-none');
        $stickyPrices.removeClass('d-none');
    } else {
        // Hide price elements when there's no valid price
        $('.cc-pdp__product__prices, .cc-stickyBar__prices').addClass('d-none');
    }

    if (xsmallImages.length) {
        $('.cc-stickyBar__productImage__img')
            .attr('src', xsmallImages[0].url)
            .attr('alt', xsmallImages[0].alt);
    }

    // Update product icons (both mobile and desktop)
    var productIcon = product.custom?.productIcon;
    var $productIcon = $('.js-productIcon');
    var $desktopProductIcon = $('.js-desktopProductIcon');

    if (productIcon) {
        var iconHtml = '<picture><img src="' + productIcon.url + '" class="js-productIcon cc-pdp__product-icon" alt="' + productIcon.alt + '" /></picture>';
        var desktopIconHtml = '<picture><img src="' + productIcon.url + '" class="js-desktopProductIcon cc-pdp__product-icon" alt="' + productIcon.alt + '" /></picture>';

        // Update mobile icon
        if ($productIcon.length) {
            $productIcon.attr('src', productIcon.url).attr('alt', productIcon.alt);
            $productIcon.parent('picture').show();
        } else {
            $('.cc-pdp__imageCarousel__header').prepend(iconHtml);
        }

        // Update desktop icon
        if ($desktopProductIcon.length) {
            $desktopProductIcon.attr('src', productIcon.url).attr('alt', productIcon.alt);
            $desktopProductIcon.parent('picture').show();
        } else {
            $('.cc-pdp__carousel__mainImage').prepend(desktopIconHtml);
        }
    } else {
        // No icon for this variant, hide if exists
        $productIcon.parent('picture').hide();
        $desktopProductIcon.parent('picture').hide();
    }

    // Update sticky bar navigation items based on product properties
    var navItems = [
        { selector: '#difference', hasContent: product.freeGift && !$.isEmptyObject(product.freeGift) },
        { selector: '#characteristics', hasContent: product.custom?.characteristics },
        { selector: '#compare', hasContent: product.custom?.productComparison }
    ];

    navItems.forEach(function (item) {
        $('.cc-stickyBar__navBar a[href="' + item.selector + '"]').toggle(!!item.hasContent);
    });

    $('.js-addToCart, .js-addToCartSticky')
        .attr('data-pid', product.id)
        .attr('data-product-name', product.productName);

    var quantityLimit = product.maxOrderQuantity || 99;
    var cartQty = product.quantityInCart || 0;
    var effectiveLimit = Math.max(quantityLimit - cartQty, 0);

    var $qtyLabelInput = $productContainer.find('.js-qtyLabel');
    var inputValue = $qtyLabelInput.length > 0 ? parseInt($qtyLabelInput.val()) : NaN;
    var selectedQuantity = (!isNaN(inputValue) && inputValue > 0)
        ? inputValue
        : (product.selectedQuantity || 1);

    selectedQuantity = parseInt(selectedQuantity, 10) || 1;

    // Validate current quantity against new effective limit
    if (selectedQuantity > effectiveLimit) {
        selectedQuantity = effectiveLimit;
    }

    $productContainer.find('.quantity-select')
        .attr('data-limit', quantityLimit)
        .attr('data-cart-qty', cartQty)
        .val(selectedQuantity);

    $productContainer.find('.js-qtyLabel')
        .attr('data-limit', quantityLimit)
        .attr('data-cart-qty', cartQty)
        .val(selectedQuantity);

    $productContainer.find('.quantity-select')
        .attr('data-limit', quantityLimit)
        .attr('data-cart-qty', cartQty)
        .val(selectedQuantity);

    var $stickyLabel = $('.cc-stickyBar').find('.js-stickyLabel');

    $stickyLabel.attr('data-limit', quantityLimit)
        .attr('data-cart-qty', cartQty)
        .val(selectedQuantity);

    var $minusButtons = $productContainer.find('.js-minusQtyPdp, .js-stickyMinusQtyPdp');
    var $plusButtons = $productContainer.find('.js-plusQtyPdp, .js-stickyPlusQtyPdp');
    var disabledClass = 'cc-pdp__product__qtyButton--disabled';

    if (selectedQuantity <= 1) {
        $minusButtons.attr('disabled', 'disabled').addClass(disabledClass);
    } else {
        $minusButtons.removeAttr('disabled').removeClass(disabledClass);
    }

    if (selectedQuantity >= effectiveLimit) {
        $plusButtons.attr('disabled', 'disabled').addClass(disabledClass);
    } else {
        $plusButtons.removeAttr('disabled').removeClass(disabledClass);
    }

    $productContainer.find('.js-tile-wishlist-btn')
        .attr('data-pid', product.id)
        .attr('data-product-name', product.productName);

    $productContainer.find('.js-tile-wishlistRemove-btn').attr('data-pid', product.id);

    // Capture values before setTimeout to avoid scope issues
    var productId = product.id;
    var productName = product.productName;
    var productUrl = product.selectedProductUrl || window.location.pathname + window.location.search;

    setTimeout(function () {
        $('.skpr-reviews-product-stars, .skpr-reviews-product-review').remove();

        var widgetsToUpdate = [
            {
                selector: '.skeepers_product__stars',
                containerSelector: '.cc-pdp__product__ratings',
                dataAttrs: { 'data-product-id': productId },
                className: 'skeepers_product__stars'
            },
            {
                selector: '.skeepers_product__reviews',
                containerSelector: '.cc-pdp__reviewsSection',
                dataAttrs: {
                    'data-product-id': productId,
                    'data-price': salesPrice,
                    'data-currency': salesCurrency,
                    'data-name': productName,
                    'data-url': productUrl,
                    'data-image-url': imageUrl
                },
                className: 'skeepers_product__reviews'
            }
        ];

        widgetsToUpdate.forEach(function (widget) {
            var $widgets = $(widget.selector);

            if ($widgets.length) {
                $widgets.each(function () {
                    var $currentWidget = $(this);

                    Object.keys(widget.dataAttrs).forEach(function (key) {
                        $currentWidget.attr(key, widget.dataAttrs[key]);
                    });

                    $currentWidget.empty();
                    $currentWidget.show();
                });
            } else {
                // Recreate widget if not found
                var $container = $(widget.containerSelector);
                if ($container.length) {
                    var dataAttrsStr = Object.keys(widget.dataAttrs)
                        .map(function (key) { return key + '="' + widget.dataAttrs[key] + '"'; })
                        .join(' ');
                    var $newWidget = $('<div class="' + widget.className + '" ' + dataAttrsStr + '></div>');
                    $container.append($newWidget);
                }
            }
        });

        // Show reviews section initially, will be hidden later if no reviews
        $('.cc-pdp__reviewsSection').show();

        // Clear any existing Skeepers state/cache
        if (window.Skeepers) {
            delete window.Skeepers;
        }

        // Force Skeepers to reload by re-executing the script
        setTimeout(function () {
            var skeepersScriptUrl = 'https://widgets.rr.skeepers.io/product/7d36b192-a0e0-22e4-f521-4b6fee9db4fb/847ba571-2f64-4ced-a7b7-522074309636.js';

            // Remove existing Skeepers scripts and add fresh one with cache-busting
            $('script[src*="skeepers.io"]').remove();

            var script = document.createElement('script');
            script.src = skeepersScriptUrl + '?t=' + new Date().getTime();
            script.async = true;
            script.onload = function () {
                setTimeout(function () {
                    var $starsWidget = $('.skeepers_product__stars');
                    var hasStarsContent = $starsWidget.find('*').length > 0 &&
                        $starsWidget.text().trim().length > 0;

                    if (!hasStarsContent) {
                        $starsWidget.hide();
                    } else {
                        $starsWidget.show();
                    }

                    var $reviewsSection = $('.cc-pdp__reviewsSection');
                    var $reviewsWidget = $('.skeepers_product__reviews');
                    var hasReviewsContent = $reviewsWidget.find('*').length > 0 &&
                        $reviewsWidget.text().trim().length > 0;

                    if (hasReviewsContent && $reviewsSection.length > 0) {
                        $reviewsSection.show();
                    } else {
                        $reviewsSection.hide();
                    }

                    var $reviewsLink = $('.cc-stickyBar__navBar a[href="#reviews"]');
                    if (hasReviewsContent && $reviewsSection.length > 0) {
                        $reviewsLink.show();
                    } else {
                        $reviewsLink.hide();
                    }
                }, 200);
            };
            document.body.appendChild(script);
        }, 100);
    }, 150);
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    var salesPriceValue = response.product.price && response.product.price.sales
        ? response.product.price.sales.value
        : null;
    var hasValidPrice = Number(salesPriceValue) > 0;

    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });

    // Handle showing/hiding out-of-stock message and buttons based on availability
    var isAvailable = (response.product.readyToOrder || response.product.productType === 'bundle') &&
        response.product.available &&
        hasValidPrice;
    var showAddToCart = !response.product.proDisplay || response.product.proDisplay.showAddToCart !== false;

    var selectors = {
        pdp: {
            outOfStock: '.cc-pdp__product__addToCartButton__outOfStock',
            quantity: '.cc-pdp__product__quantity',
            addToCart: '.cc-pdp__product__addToCartButton__wrapper'
        },
        sticky: {
            outOfStock: '.cc-stickyBar__buttonsWrapper .cc-pdp__product__addToCartButton__outOfStock',
            quantity: '.cc-stickyBar__buttonsWrapper .cc-pdp__product__qtyButtonWrapper',
            addToCart: '.cc-stickyBar__buttonsWrapper .cc-stickyBar__addToCartButton__wrapper'
        }
    };

    // Update PDP elements
    if (isAvailable) {
        $productContainer.find(selectors.pdp.outOfStock).addClass('d-none');
        $productContainer.find(selectors.pdp.quantity).toggleClass('d-none', !showAddToCart);
        $productContainer.find(selectors.pdp.addToCart).toggleClass('d-none', !showAddToCart);
    } else {
        $productContainer.find(selectors.pdp.outOfStock).removeClass('d-none');
        $productContainer.find(selectors.pdp.quantity).addClass('d-none');
        $productContainer.find(selectors.pdp.addToCart).addClass('d-none');
    }

    // Update sticky bar elements
    if (isAvailable) {
        $(selectors.sticky.outOfStock).addClass('d-none');
        $(selectors.sticky.quantity).toggleClass('d-none', !showAddToCart);
        $(selectors.sticky.addToCart).toggleClass('d-none', !showAddToCart);
    } else {
        $(selectors.sticky.outOfStock).removeClass('d-none');
        $(selectors.sticky.quantity).addClass('d-none');
        $(selectors.sticky.addToCart).addClass('d-none');
    }
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.js-productOptions').empty().html(optionsHtml);
}

function getRegularDeliveryOption(product) {
    if (!product || !product.options || !product.options.length) {
        return null;
    }
    return product.options.find(function (option) {
        return option.id === 'regularDeliveryOption';
    }) || null;
}

function getRegularDeliveryOptionFromHtml(optionsHtml) {
    if (!optionsHtml) {
        return null;
    }
    var $optionsRoot = $('<div>').html(optionsHtml);
    var $regularDeliverySelect = $optionsRoot.find('[data-option-id="regularDeliveryOption"] .options-select').first();
    if (!$regularDeliverySelect.length) {
        return null;
    }
    var values = $regularDeliverySelect.find('option').map(function () {
        return {
            id: $(this).data('value-id'),
            url: $(this).val(),
            displayValue: $(this).text()
        };
    }).toArray().filter(function (value) {
        return value.id;
    });
    if (!values.length) {
        return null;
    }
    var $selectedOption = $regularDeliverySelect.find('option:selected').first();
    var selectedValueId = $selectedOption.data('value-id') || values[0].id;
    return {
        id: 'regularDeliveryOption',
        selectedValueId: selectedValueId,
        values: values
    };
}

function escapeHtmlAttribute(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function buildRegularDeliveryMarkup(rdOption, product, standardValueId, labels) {
    var currentSelectedValueId = rdOption.selectedValueId;
    var isRDSelected = !!(currentSelectedValueId && currentSelectedValueId !== standardValueId);
    var onetimeFormattedPrice = product.price && product.price.sales ? product.price.sales.formatted : '';
    var rdFormattedPrice = product.regularDeliveryPrice ? product.regularDeliveryPrice.formatted : '';
    var rdDiscount = product.regularDeliveryDiscountPercentage || { value: 0, formatted: '0 %' };
    var onetimeLabel = labels.onetimeLabel || '';
    var subscribeLabel = labels.subscribeLabel || '';
    var discountLabelTemplate = labels.discountLabelTemplate || '{0}';
    var infoLabel = labels.infoLabel || '';
    var chooseFrequencyLabel = labels.chooseFrequencyLabel || '';
    var frequencyTemplate = labels.frequencyTemplate || '{0}';
    var rdValue = rdOption.values.find(function (value) { return value.id !== standardValueId; });
    if (!rdValue) { return ''; }
    var rdLabel = rdDiscount.value > 0 ? discountLabelTemplate.replace('{0}', rdDiscount.formatted) : subscribeLabel;
    var onetimeLabelAttr = escapeHtmlAttribute(onetimeLabel);
    var subscribeLabelAttr = escapeHtmlAttribute(subscribeLabel);
    var discountLabelTemplateAttr = escapeHtmlAttribute(discountLabelTemplate);
    var optionsMarkup = rdOption.values.map(function (value) {
        var selected = value.id === currentSelectedValueId ? ' selected' : '';
        return '<option data-value-id="' + value.id + '" value="' + value.url + '"' + selected + '>' + value.displayValue + '</option>';
    }).join('');
    var frequencyOptions = (product.regularDeliveryFrequencies || []).map(function (freq, index) {
        var months = Math.round(freq / 30);
        var frequencyLabel = frequencyTemplate.replace('{0}', months);
        var selected = index === 0 ? ' selected' : '';
        return '<option value="' + freq + '"' + selected + '>' + frequencyLabel + '</option>';
    }).join('');
    return ''
        + '<div class="cc-pdp__regularDelivery js-regularDelivery product-option"'
        + ' data-option-id="regularDeliveryOption"'
        + ' data-rd-price="' + (product.regularDeliveryPrice ? product.regularDeliveryPrice.value : '') + '"'
        + ' data-rd-discount="' + (rdDiscount.value || 0) + '"'
        + ' data-default-value-id="' + standardValueId + '"'
        + ' data-onetime-label="' + onetimeLabelAttr + '"'
        + ' data-subscribe-label="' + subscribeLabelAttr + '"'
        + ' data-discount-label-template="' + discountLabelTemplateAttr + '">'
        + '<select class="options-select cc-pdp__hiddenOption" name="regularDeliveryOption">'
        + optionsMarkup
        + '</select>'
        + '<div class="cc-pdp__regularDelivery__toggle cc-form">'
        + '<div class="cc-pdp__regularDelivery__option ' + (!isRDSelected ? 'active ' : '') + 'cc-form__wrp cc-form__wrp--radio">'
        + '<input type="radio" name="purchaseType" id="purchaseType_' + standardValueId + '" value="' + standardValueId + '"'
        + ' class="form-control cc-form__radio js-form-control js-purchaseType" data-value-id="' + standardValueId + '"' + (!isRDSelected ? ' checked' : '') + ' />'
        + '<label class="cc-form__radio-label cc-pdp__regularDelivery__label" for="purchaseType_' + standardValueId + '">'
        + '<p class="cc-text-md font-weight-bold cc-pdp__regularDelivery__optionText">' + onetimeLabel + '</p>'
        + '<p class="cc-text-md cc-pdp__regularDelivery__optionPrice">' + onetimeFormattedPrice + '</p>'
        + '</label>'
        + '</div>'
        + '<div class="cc-pdp__regularDelivery__option ' + (isRDSelected ? 'active' : '') + '">'
        + '<div class="cc-form__wrp cc-form__wrp--radio">'
        + '<input type="radio" name="purchaseType" id="purchaseType_' + rdValue.id + '" value="' + rdValue.id + '"'
        + ' class="form-control cc-form__radio js-form-control js-purchaseType" data-value-id="' + rdValue.id + '"' + (isRDSelected ? ' checked' : '') + ' />'
        + '<label class="cc-form__radio-label cc-pdp__regularDelivery__label" for="purchaseType_' + rdValue.id + '">'
        + '<p class="cc-text-md font-weight-bold cc-pdp__regularDelivery__optionText">' + rdLabel + '</p>'
        + '<p class="cc-text-md cc-pdp__regularDelivery__optionPrice js-rdPriceDisplay">' + rdFormattedPrice + '</p>'
        + '</label>'
        + '</div>'
        + '<div class="cc-pdp__regularDelivery__frequency js-rdFrequencyWrapper ' + (!isRDSelected ? 'd-none' : '') + '">'
        + '<p class="cc-text-sm cc-mt-sm">' + infoLabel + '</p>'
        + '<div class="cc-pdp__regularDelivery__chooseFrequency">'
        + '<span class="cc-pdp__regularDelivery__chooseFrequency__label">' + chooseFrequencyLabel + '</span>'
        + '<div class="cc-form__wrp cc-form__wrp--select cc-pdp__regularDelivery__frequencySelect">'
        + '<select id="rdFrequency" class="form-control cc-form__select js-sp js-form-control js-rdFrequency">'
        + frequencyOptions
        + '</select>'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';
}

function updateRegularDeliverySection(product, $productContainer, optionsHtml) {
    var $regularDeliveryWrapper = $productContainer.find('.js-regularDeliveryWrapper').first();
    var $regularDelivery = $regularDeliveryWrapper.find('.js-regularDelivery').first();
    if (!$regularDeliveryWrapper.length) { return; }

    var rdOption = getRegularDeliveryOption(product) || getRegularDeliveryOptionFromHtml(optionsHtml);
    var shouldShowRegularDelivery = !!(rdOption && product.regularDelivery && product.regularDeliveryPrice);

    $regularDeliveryWrapper.toggleClass('d-none', !shouldShowRegularDelivery);

    if (!rdOption) {
        if ($regularDelivery.length) { $regularDelivery.removeClass('product-option'); }
        return;
    }

    var currentSelectedValueId = rdOption.selectedValueId;
    var existingDefaultValueId = $regularDelivery.attr('data-default-value-id');
    var explicitStandardValue = rdOption.values.find(function (value) {
        return String(value.id).toLowerCase() === 'standard';
    });
    var standardValueId = explicitStandardValue ? explicitStandardValue.id : existingDefaultValueId;

    if (!standardValueId || !rdOption.values.some(function (value) { return value.id === standardValueId; })) {
        standardValueId = currentSelectedValueId;
    }

    var onetimeLabel = $regularDelivery.attr('data-onetime-label') || $regularDeliveryWrapper.attr('data-onetime-label') || '';
    var subscribeLabel = $regularDelivery.attr('data-subscribe-label') || $regularDeliveryWrapper.attr('data-subscribe-label') || '';
    var discountLabelTemplate = $regularDelivery.attr('data-discount-label-template') || $regularDeliveryWrapper.attr('data-discount-label-template') || '{0}';
    var infoLabel = $regularDeliveryWrapper.attr('data-info-label') || '';
    var chooseFrequencyLabel = $regularDeliveryWrapper.attr('data-choosefrequency-label') || '';
    var frequencyTemplate = $regularDeliveryWrapper.attr('data-frequency-template') || '{0}';
    var onetimeFormattedPrice = product.price && product.price.sales ? product.price.sales.formatted : '';
    var rdFormattedPrice = product.regularDeliveryPrice ? product.regularDeliveryPrice.formatted : '';
    var rdDiscount = product.regularDeliveryDiscountPercentage || { value: 0, formatted: '0 %' };

    if (!$regularDelivery.length && shouldShowRegularDelivery) {
        var rdMarkup = buildRegularDeliveryMarkup(rdOption, product, standardValueId, {
            onetimeLabel: onetimeLabel, subscribeLabel: subscribeLabel,
            discountLabelTemplate: discountLabelTemplate, infoLabel: infoLabel,
            chooseFrequencyLabel: chooseFrequencyLabel, frequencyTemplate: frequencyTemplate
        });
        if (rdMarkup) {
            $regularDeliveryWrapper.html(rdMarkup);
            $regularDelivery = $regularDeliveryWrapper.find('.js-regularDelivery').first();
        }
    }

    if (!$regularDelivery.length) { return; }

    $regularDelivery.toggleClass('product-option', shouldShowRegularDelivery);
    $regularDelivery.attr('data-default-value-id', standardValueId);
    $regularDelivery.attr('data-rd-price', product.regularDeliveryPrice ? product.regularDeliveryPrice.value : '');
    $regularDelivery.attr('data-rd-discount', rdDiscount.value || 0);

    var $select = $regularDelivery.find('.options-select').first();
    if ($select.length) {
        var optionsMarkup = rdOption.values.map(function (value) {
            var selected = value.id === currentSelectedValueId ? ' selected' : '';
            return '<option data-value-id="' + value.id + '" value="' + value.url + '"' + selected + '>' + value.displayValue + '</option>';
        }).join('');
        $select.html(optionsMarkup);
    }

    var $regularDeliveryOptions = $regularDelivery.find('.cc-pdp__regularDelivery__option');
    if ($regularDeliveryOptions.length < 2) { return; }

    var $onetimeOption = $regularDeliveryOptions.eq(0);
    var $rdOptionElement = $regularDeliveryOptions.eq(1);

    // Prefer the user's current DOM selection over the server-provided selectedValueId
    var $domChecked = $regularDelivery.find('.js-purchaseType:checked');
    var domSelectedValueId = $domChecked.length ? $domChecked.data('value-id') : null;
    var isRDSelected = domSelectedValueId
        ? !!(standardValueId && domSelectedValueId !== standardValueId)
        : !!(currentSelectedValueId && currentSelectedValueId !== standardValueId);

    $onetimeOption.toggleClass('active', !isRDSelected);
    $onetimeOption.find('.js-purchaseType').attr('id', 'purchaseType_' + standardValueId).data('value-id', standardValueId).prop('checked', !isRDSelected);
    $onetimeOption.find('.cc-pdp__regularDelivery__label').attr('for', 'purchaseType_' + standardValueId);
    $onetimeOption.find('.cc-pdp__regularDelivery__optionText').text(onetimeLabel);
    $onetimeOption.find('.cc-pdp__regularDelivery__optionPrice').text(onetimeFormattedPrice);

    var rdValue = rdOption.values.find(function (value) { return value.id !== standardValueId; });
    if (!rdValue) { $regularDeliveryWrapper.addClass('d-none'); return; }

    var rdLabel = rdDiscount.value > 0 ? discountLabelTemplate.replace('{0}', rdDiscount.formatted) : subscribeLabel;

    $rdOptionElement.toggleClass('active', isRDSelected);
    $rdOptionElement.find('.js-purchaseType').attr('id', 'purchaseType_' + rdValue.id).data('value-id', rdValue.id).prop('checked', isRDSelected);
    $rdOptionElement.find('.cc-pdp__regularDelivery__label').attr('for', 'purchaseType_' + rdValue.id);
    $rdOptionElement.find('.cc-pdp__regularDelivery__optionText').html(rdLabel);
    $rdOptionElement.find('.js-rdPriceDisplay').text(rdFormattedPrice);
    $rdOptionElement.find('.js-rdFrequencyWrapper').toggleClass('d-none', !isRDSelected);
}

/**
 * Dynamically creates Slick carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object[]} mediumImgs - Array of medium product images for main display
 */
function createCarousel(imgs, $productContainer, mediumImgs) {
    const $carouselSlider = $productContainer.find('.cc-pdp__carousel__slider');
    const $carouselPrevArrow = $productContainer.find('.js-carouselPrev');
    const $carouselNextArrow = $productContainer.find('.js-carouselNext');

    $carouselSlider.slick('unslick');
    $carouselSlider.empty();

    var imageLoadPromises = [];

    for (var i = 0; i < imgs.length; i++) {
        var indexImage = i;
        var imageHtml = `<button class="cc-pdp__carousel__item" data-main-image-url="${imgs[indexImage].url}" data-slide-type="image" data-toggle="modal" data-target="#zoomImageModal">
            <picture class="cc-pdp__carousel__item__picture cc-pdp__item__picture">
                <img src="${imgs[indexImage].url}" class="cc-pdp__carousel__item__img"
                    alt="${imgs[indexImage].alt} image number ${imgs[indexImage].index}" itemprop="image" ${imgs[indexImage].index != 0 ? "loading='lazy'" : ''} />
            </picture>
        </button>`;
        $(imageHtml).appendTo($carouselSlider);
    }

    /* Add video HTML to carousel
    if (video.url) {
        var videoHtml = `<div class="cc-pdp__video__item">
            <video class="cc-pdp__video js-videoControl" autoplay muted loop playsinline>
                <source data-src-desktop="${video.url}"
                <source data-src-mobile="${video.url}"
                type="video/mp4">
            </video>
        </div>`;
        $(videoHtml).appendTo($carouselSlider);
        var video = require('./productDetailVideo');
        video.loadVideo();
    }*/

    // Wait for all images to load before initializing slick
    $carouselSlider.find('img').each(function () {
        var promise = new Promise(function (resolve) {
            var img = this;
            if (img.complete) {
                resolve();
            } else {
                $(img).on('load error', function () {
                    resolve();
                });
            }
        }.bind(this));
        imageLoadPromises.push(promise);
    });

    Promise.all(imageLoadPromises).then(function () {
        // Update the main image
        var $mainImage = $productContainer.find('.js-carouselMainImage');
        var mainImageSource = mediumImgs && mediumImgs.length > 0 ? mediumImgs : imgs;
        if ($mainImage.length && mainImageSource.length > 0) {
            $mainImage.attr('src', mainImageSource[0].url);
            $mainImage.attr('alt', mainImageSource[0].url);
            $mainImage.attr('alt', imgs[0].alt);
        }

        $(document).trigger('product:updateCarousel');
    });
}

/**
 * Dynamically creates Slick zoom image carousel from response containing images and video
 * @param {Object[]} largeImgs - Array of large product images for zoom view
 * @param {Object[]} smallImgs - Array of small product images for zoom navigation
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} video - Video object with url property (optional)
 */
function createZoomCarousel(largeImgs, smallImgs, $productContainer, video) {
    const $zoomImageModal = $('#zoomImageModal');
    const $zoomCarousel = $zoomImageModal.find('.cc-pdp__zoomImage__slider');
    const $zoomNavCarousel = $zoomImageModal.find('.cc-pdp__zoomImage__navCarousel__slider');

    // Destroy previous carousel instances if they exist
    if ($zoomCarousel.hasClass('slick-initialized')) {
        $zoomCarousel.slick('unslick');
    }
    if ($zoomNavCarousel.hasClass('slick-initialized')) {
        $zoomNavCarousel.slick('unslick');
    }

    // Update main zoom slider
    $zoomCarousel.empty();

    for (var i = 0; i < largeImgs.length; i++) {
        var imageHtml = `<div class="cc-pdp__zoomImage__item">
            <picture class="cc-pdp__zoomImage__item__picture cc-pdp__item__picture">
                <img src="${largeImgs[i].url}" class="cc-pdp__zoomImage__item__img"
                    alt="${largeImgs[i].alt} image number ${largeImgs[i].index}" itemprop="image" ${largeImgs[i].index != 0 ? "loading='lazy'" : ''} />
            </picture>
        </div>`;
        $(imageHtml).appendTo($zoomCarousel);
    }

    // Add video to main carousel if it exists
    if (video && video.url) {
        var videoHtml = `<div class="cc-pdp__zoomImage__item">
            <video class="cc-pdp__video cc-pdp__video--zoom js-videoControl" controls autoplay muted loop playsinline>
                <source src="${video.url}" type="video/webm">
                <source src="${video.url}" type="video/mp4">
            </video>
        </div>`;
        $(videoHtml).appendTo($zoomCarousel);
    }

    // Update navigation slider
    $zoomNavCarousel.empty();

    for (var j = 0; j < smallImgs.length; j++) {
        var navImageHtml = `<button class="cc-pdp__carousel__item">
                <picture class="cc-pdp__carousel__item__picture cc-pdp__item__picture">
                    <img src="${smallImgs[j].url}" class="cc-pdp__carousel__item__img" alt="${smallImgs[j].alt} image number ${smallImgs[j].index}"
                        itemprop="image" ${smallImgs[j].index != 0 ? "loading='lazy'" : ''} />
                </picture>
            </button>`;
        $(navImageHtml).appendTo($zoomNavCarousel);
    }

    // Zoom Carousel Initialization
    $zoomImageModal.off('shown.bs.modal').on('shown.bs.modal', function () {
        const initialSlide = $zoomImageModal.data('initial-slide') || 0;
        const $carouselAccessibilityLabels = $('#carouselAccessibilityLabels');
        const previousSlideLabel = $carouselAccessibilityLabels.attr('data-previous-slide-label') || '';
        const nextSlideLabel = $carouselAccessibilityLabels.attr('data-next-slide-label') || '';

        $zoomCarousel.slick({
            arrows: true,
            prevArrow: `<button type="button" class="slick-prev slick-arrow" aria-label="${previousSlideLabel}"></button>`,
            nextArrow: `<button type="button" class="slick-next slick-arrow" aria-label="${nextSlideLabel}"></button>`,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: initialSlide,
            infinite: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        asNavFor: $zoomNavCarousel,
                    }
                }
            ]
        });

        $zoomNavCarousel.slick({
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: $zoomCarousel,
            focusOnSelect: true,
            infinite: false,
        });

        $zoomCarousel.addClass('is-visible');
        $zoomNavCarousel.addClass('is-visible');
    });

    $zoomImageModal.off('hidden.bs.modal').on('hidden.bs.modal', function () {
        if ($zoomCarousel.hasClass('slick-initialized')) {
            $zoomCarousel.slick('unslick');
        }
        if ($zoomNavCarousel.hasClass('slick-initialized')) {
            $zoomNavCarousel.slick('unslick');
        }

        $zoomCarousel.removeClass('is-visible');
        $zoomNavCarousel.removeClass('is-visible');
    });

}

/**
 * Updates the main punisher element based on the product's mainPunisher data.
 * Shows and updates the element if data is present, hides it otherwise.
 *
 * @param {Object|null} mainPunisher - The mainPunisher data from the product model
 * @param {Object} resources - Resource strings from the AJAX response
 */
function updateMainPunisher(mainPunisher, resources) {
    var $punisherEl = $('.cc-pdp__promotion__standard');

    if (!mainPunisher) {
        $punisherEl.addClass('d-none');
        return;
    }

    var styleStr = '';
    if (mainPunisher.textColor) {
        styleStr += '--main-punisher-color: ' + mainPunisher.textColor + '; ';
    }
    if (mainPunisher.backgroundColor) {
        styleStr += '--main-punisher-bg-color: ' + mainPunisher.backgroundColor + ';';
    }

    var descriptionHtml = '';
    if (mainPunisher.fixDiscountDisplayValue && resources && resources.label_punisher_text_discount) {
        descriptionHtml = resources.label_punisher_text_discount.replace('{0}', mainPunisher.fixDiscountDisplayValue);
    } else if (mainPunisher.text) {
        descriptionHtml = mainPunisher.text;
    }

    var tooltipHtml = '';
    if (mainPunisher.tooltipText) {
        var infoIconUrl = ($('.cc-icon use').first().attr('xlink:href') || '').replace(/#.*$/, '#icon-info-circle');
        var tooltipStyle = 'text-decoration: none;';
        if (mainPunisher.textColor) {
            tooltipStyle += ' color: ' + mainPunisher.textColor + ';';
        }
        tooltipHtml = '<button type="button" class="cc-link js-punisherTooltip" data-toggle="tooltip" data-placement="top"'
            + ' style="' + tooltipStyle + '">'
            + '<span class="cc-icon cc-icon--icon-info-circle cc-pdp__promotion__standard__icon"'
            + ' role="presentation" aria-hidden="true" focusable="false">'
            + '<svg class="cc-svg cc-svg--small" aria-hidden="true" focusable="false">'
            + '<use xlink:href="' + infoIconUrl + '"></use>'
            + '</svg></span>'
            + '</button>';
    }

    var promoCodeHtml = '';
    if (mainPunisher.promoCode) {
        var copyIconUrl = ($('.cc-icon use').first().attr('xlink:href') || '').replace(/#.*$/, '#icon-copy');
        var promoCodeStyle = mainPunisher.backgroundColor ? ' style="color: ' + mainPunisher.backgroundColor + ';"' : '';
        var ariaLabelVal = (resources && resources.label_copy_promo_code) ? $('<span>').text(resources.label_copy_promo_code).html() : '';
        var codeCopiedText = (resources && resources.label_promo_code_copied) ? $('<span>').text(resources.label_promo_code_copied).html() : '';
        promoCodeHtml = '<button class="cc-pdp__promotion__codeBtn js-copyPromoCode" type="button"'
            + ' aria-label="' + ariaLabelVal + '"' + promoCodeStyle + '>'
            + '<span class="cc-pdp__promotion__code js-promoCodeCopy">'
            + $('<span>').text(mainPunisher.promoCode).html()
            + ' <span class="cc-icon cc-icon--icon-copy" role="presentation" aria-hidden="true" focusable="false">'
            + '<svg class="cc-svg cc-svg--small" aria-hidden="true" focusable="false">'
            + '<use xlink:href="' + copyIconUrl + '"></use>'
            + '</svg></span>'
            + '</span>'
            + '<span class="cc-pdp__promotion__code js-promoCodeCopied d-none">' + codeCopiedText + '</span>'
            + '</button>';
    }

    var innerHtml = '<div class="cc-pdp__promotion cc-pdp__promotion__standard__text">'
        + '<span class="cc-pdp__promotion__description">' + descriptionHtml + '</span>'
        + tooltipHtml
        + '</div>'
        + promoCodeHtml;

    if ($punisherEl.length) {
        if (styleStr) {
            $punisherEl.attr('style', styleStr);
        } else {
            $punisherEl.removeAttr('style');
        }
        $punisherEl.html(innerHtml).removeClass('d-none');
    } else {
        var $newPunisher = $('<div>', { class: 'cc-pdp__promotion cc-pdp__promotion__standard cc-text-sm' });
        if (styleStr) {
            $newPunisher.attr('style', styleStr);
        }
        $newPunisher.html(innerHtml);
        $('.promotions').after($newPunisher);
    }

    if (mainPunisher.tooltipText) {
        $('.cc-pdp__promotion__standard .js-punisherTooltip')
            .attr('title', mainPunisher.tooltipText)
            .tooltip({ html: true });
    }
}

function updateExtraPunisher(extraPunisher, $productContainer) {
    var $refundPromotion = $productContainer.find('.cc-pdp__promotion__refund').first();

    if (!extraPunisher) {
        $refundPromotion.remove();
        return;
    }

    if (!$refundPromotion.length) {
        $refundPromotion = $('<div class="cc-pdp__promotion cc-pdp__promotion__refund w-100">'
            + '<span class="cc-pdp__promotion__description"></span>'
            + '<a class="cc-pdp__promotion__refund__link cc-link cc-link--sm"><span></span></a>'
            + '</div>');

        var $addToCartWrapper = $productContainer.find('.cc-pdp__product__addToCartWrapper').first();
        if ($addToCartWrapper.length) {
            $refundPromotion.insertAfter($addToCartWrapper);
        } else {
            $productContainer.find('.cc-pdp__product').append($refundPromotion);
        }
    }

    var $description = $refundPromotion.find('.cc-pdp__promotion__description');
    var $link = $refundPromotion.find('.cc-pdp__promotion__refund__link');

    if (extraPunisher.backgroundColor) {
        $refundPromotion[0].style.setProperty('--extra-punisher-bg-color', extraPunisher.backgroundColor);
    } else {
        $refundPromotion[0].style.removeProperty('--extra-punisher-bg-color');
    }

    $description.css('color', extraPunisher.textColor || '').html(extraPunisher.text || '');
    $link.attr('href', extraPunisher.link || '').find('span').html(extraPunisher.ctaText || '');
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var resources = response.resources || {};
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    updateProductContent(response.product, response.resources, $productContainer, response.product.optionsHtml);

    var $mainImageButton = $productContainer.find('.js-mainImageButton');
    var imageLabelTemplate = $mainImageButton.attr('data-image-label-template');
    var productName = response.product.productName;
    var imageLabel = productName && imageLabelTemplate
        ? imageLabelTemplate.replace('{0}', productName)
        : $mainImageButton.attr('data-image-label-generic');
    if ($mainImageButton.length && imageLabel) {
        $mainImageButton.attr('aria-label', imageLabel);
    }

    if (!isChoiceOfBonusProducts) {
        updateProductUrl(response.product.selectedProductUrl);
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    var mediumImageUrls = response.product.images.medium;
    var smallImageUrls = response.product.images.small;
    createCarousel(primaryImageUrls, $productContainer, mediumImageUrls);

    // Update zoom carousel
    createZoomCarousel(primaryImageUrls, smallImageUrls, $productContainer, response.product.video);

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    // Update main punisher visibility and content for the selected variant
    updateMainPunisher(response.product.mainPunisher, response.resources);
    updateExtraPunisher(response.product.extraPunisher, $productContainer);

    // Update free delivery section based on variant promotions
    var freeDeliveryPromotion = response.product.promotions?.find(function (promo) {
        return promo.promotionClass === 'SHIPPING';
    });

    var $freeDeliverySection = $productContainer.find('.cc-pdp__freeDelivery');

    if (freeDeliveryPromotion && freeDeliveryPromotion.calloutMsg) {
        if (!$freeDeliverySection.length) {
            var iconUrl = ($('.cc-icon use').first().attr('xlink:href') || '').replace(/#.*$/, '#icon-truck');
            var freeDeliveryHtml =
                '<div class="cc-pdp__freeDelivery">' +
                '<span class="cc-icon cc-icon--icon-truck cc-color-grey-700" role="presentation" aria-hidden="true" focusable="false">' +
                '<svg class="cc-svg cc-svg--small" aria-hidden="true" focusable="false">' +
                '<use xlink:href="' + iconUrl + '"></use>' +
                '</svg>' +
                '</span>' +
                '<span class="cc-pdp__freeDelivery__text">' + freeDeliveryPromotion.calloutMsg + '</span>' +
                '</div>';

            // Insert after product availability or before benefit points
            var $benefitPoints = $productContainer.find('.cc-pdp__benefitPoints');
            var $productAvailability = $productContainer.find('.cc-pdp__product__availability');

            if ($benefitPoints.length) {
                $benefitPoints.before(freeDeliveryHtml);
            } else if ($productAvailability.length) {
                $productAvailability.after(freeDeliveryHtml);
            } else {
                $productContainer.find('.cc-pdp__product__attributes').append(freeDeliveryHtml);
            }
        } else {
            // Update existing section
            var $textElement = $freeDeliverySection.find('.cc-pdp__freeDelivery__text');
            if ($textElement.length) {
                $textElement.html(freeDeliveryPromotion.calloutMsg);
            } else {
                // Fallback: wrap the message if no text wrapper exists
                var $icon = $freeDeliverySection.find('.cc-icon');
                $icon.nextAll().remove();
                $freeDeliverySection.contents().filter(function () { return this.nodeType === 3; }).remove();
                $icon.after('<span class="cc-pdp__freeDelivery__text">' + freeDeliveryPromotion.calloutMsg + '</span>');
            }
            $freeDeliverySection.show();
        }
    } else {
        $freeDeliverySection.hide();
    }

    // Update benefit points section based on variant
    var benefitPoints = response.product.custom?.physicalProductAttributes?.benefitsPoints;
    var $benefitPointsSection = $productContainer.find('.cc-pdp__benefitPoints');

    if (benefitPoints) {
        if (!$benefitPointsSection.length) {
            var benefitPointsHtml = '<div class="cc-pdp__benefitPoints js-benefitPoints">' + benefitPoints + '</div>';
            $productContainer.find('.cc-pdp__product__attributes').append(benefitPointsHtml);
        } else {
            $benefitPointsSection.html(benefitPoints).show();
        }
    } else {
        $benefitPointsSection.hide();
    }

    // Update productDifference section based on variant's freeGift
    var freeGift = response.product.freeGift;
    var hasFreeGift = freeGift && !$.isEmptyObject(freeGift);
    var $differenceSection = $('.cc-pdp__differenceSection');

    if (hasFreeGift) {
        if ($differenceSection.length) {
            $differenceSection.show();

            // Update first card with freeGift name, picture and description
            var $firstCard = $differenceSection.find('.cc-pdp__differenceSection__card').first();

            // Cache original server-rendered HTML (content asset fallback) before first modification
            if ($firstCard.data('original-html') === undefined) {
                $firstCard.data('original-html', $firstCard.html());
            }

            var giftShortDescription = freeGift.giftShortDescription && (freeGift.giftShortDescription.markup || freeGift.giftShortDescription.source);
            var giftBentoBoxBody = freeGift.giftBentoBoxBody && (freeGift.giftBentoBoxBody.markup || freeGift.giftBentoBoxBody.source);
            var hasStructuredGift = freeGift.giftName || (freeGift.giftPicture && freeGift.giftPicture.absURL) || (freeGift.giftDescription && freeGift.giftDescription.markup) || giftShortDescription;
            if (hasStructuredGift) {
                var giftPictureUrl = freeGift.giftPicture && freeGift.giftPicture.absURL;
                var backgroundStyle = giftPictureUrl
                    ? ' style="background-image: url(&quot;' + escapeHtmlAttribute(giftPictureUrl) + '&quot;);"'
                    : '';
                var offerTitle = $('<span>').text(resources.label_product_offers || '').html();
                var offerSubtitle = $('<span>').text(resources.label_product_offers_text || '').html();
                var offerNote = $('<span>').text(resources.label_product_offers_note || '').html();
                var firstCardHtml = '<div class="cc-pdp__differenceSection__card__wrapper gift-card"' + backgroundStyle + '>'
                    + '<div class="cc-pdp__differenceSection__card__content">'
                    + '<p class="cc-heading-xl">' + offerTitle + '</p>'
                    + '<p class="cc-pdp__differenceSection__card__subTitle cc-text-sm">' + offerSubtitle + '</p>'
                    + (giftShortDescription ? '<p class="cc-text-sm">' + giftShortDescription + '</p>' : '')
                    + '</div>'
                    + '<p class="cc-pdp__differenceSection__card__note cc-text-xs">' + offerNote + '</p>'
                    + '</div>';
                $firstCard.html(firstCardHtml);
            } else if (giftBentoBoxBody) {
                $firstCard.html(giftBentoBoxBody);
            } else {
                // freeGift is asset-based only — restore the original server-rendered content asset
                $firstCard.html($firstCard.data('original-html'));
            }

            // Update extraPunisher content in the last card if variant has it
            var extraPunisher = response.product.extraPunisher?.body?.markup;
            if (extraPunisher) {
                $differenceSection.find('.cc-pdp__differenceSection__card').last().html(extraPunisher);
            }
        } else {
            console.log('productDifference section needs to be created for variant with freeGift');
        }
    } else {
        $differenceSection.hide();
    }

    // Update offers pill visibility (mobile + desktop)
    var $mobileOffers = $('.js-mobileOffers');
    var $desktopOffers = $('.js-desktopOffers');
    var $mobileHighlighted = $('.js-mobileHighlightedAttributes');
    var $desktopHighlighted = $('.js-desktopHighlightedAttributes');

    if (hasFreeGift) {
        $mobileOffers.removeClass('d-none').addClass('d-flex').removeClass('d-lg-none');
        $mobileOffers.addClass('d-lg-none');
        $desktopOffers.removeClass('d-none').addClass('d-lg-flex');
        $mobileHighlighted.addClass('d-none').removeClass('d-flex').removeClass('d-lg-none');
        $desktopHighlighted.addClass('d-none').removeClass('d-lg-flex');

        // Update offer tile image
        var pillsizedUrl = freeGift.pillsizedGiftPicture && freeGift.pillsizedGiftPicture.absURL;
        var giftImageUrl = freeGift.giftImage && freeGift.giftImage.absURL;
        var offerImgSrc = pillsizedUrl || giftImageUrl || '';
        var offerImgAlt = freeGift.giftName || '';
        var $offerImg = $('.js-mobileOffers .cc-pdp__offers__image, .js-desktopOffers .cc-pdp__offers__image');
        if (offerImgSrc) {
            $offerImg.attr('src', offerImgSrc).attr('alt', offerImgAlt).closest('picture').show();
        } else {
            $offerImg.closest('picture').hide();
        }
    } else {
        $mobileOffers.addClass('d-none').removeClass('d-flex').removeClass('d-lg-none');
        $desktopOffers.addClass('d-none').removeClass('d-lg-flex');

        var keyPointsLength = response.product.custom && response.product.custom.keyPoints && response.product.custom.keyPoints.elements
            ? response.product.custom.keyPoints.elements.length
            : 0;

        if (keyPointsLength > 0) {
            $mobileHighlighted.removeClass('d-none').addClass('d-flex').addClass('d-lg-none');
            $desktopHighlighted.removeClass('d-none').addClass('d-lg-flex');
        } else {
            $mobileHighlighted.addClass('d-none');
            $desktopHighlighted.addClass('d-none');
        }
    }

    // Update offersModal content
    var $offersModal = $('#offersModal');
    var $modalContent = $offersModal.find('.cc-modal__content');
    $modalContent.empty();

    if (hasFreeGift) {
        var hasStructuredContent = freeGift.giftName || (freeGift.giftPicture && freeGift.giftPicture.absURL) || (freeGift.giftDescription && freeGift.giftDescription.markup) || (freeGift.giftShortDescription && freeGift.giftShortDescription.markup);
        var iconUrl = ($('.cc-icon use').first().attr('xlink:href') || '').replace(/#.*$/, '#icon-x');

        if (hasStructuredContent) {
            var modalHtml = '<div class="cc-modal__header">';
            if (freeGift.giftName) {
                modalHtml += '<span class="cc-modal__title cc-heading-sm">' + $('<span>').text(freeGift.giftName).html() + '</span>';
            }
            modalHtml += '<button type="button" class="cc-modal__close" data-dismiss="modal" aria-label="Close">' +
                '<span class="cc-icon cc-icon--icon-x" role="presentation" aria-hidden="true" focusable="false">' +
                '<svg class="cc-svg cc-svg--small" aria-hidden="true" focusable="false">' +
                '<use xlink:href="' + iconUrl + '"></use>' +
                '</svg>' +
                '</span>' +
                '</button>';
            modalHtml += '</div>';
            modalHtml += '<div class="cc-modal__body d-flex flex-column cc-gap-xl">';
            if (freeGift.giftPicture && freeGift.giftPicture.absURL) {
                var giftPictureAlt = freeGift.giftName ? $('<span>').text(freeGift.giftName).html() : '';
                modalHtml += '<picture><img src="' + freeGift.giftPicture.absURL + '" width="100%" height="auto" alt="' + giftPictureAlt + '" /></picture>';
            }
            if (freeGift.giftDescription && freeGift.giftDescription.markup) {
                modalHtml += freeGift.giftDescription.markup;
            }
            if (freeGift.giftShortDescription && freeGift.giftShortDescription.markup) {
                modalHtml += freeGift.giftShortDescription.markup;
            }
            modalHtml += '</div>';
            $modalContent.html(modalHtml);
        }

        if (freeGift.body && freeGift.body.markup) {
            $modalContent.append(freeGift.body.markup);
        }
    }

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.js-addToCart, button.js-addToCartSticky, button.add-to-cart-global, button.update-cart-product-global')
            .trigger('product:updateAddToCart', {
                product: response.product, $productContainer: $productContainer
            }).trigger('product:statusUpdate', response.product);

        if ((!response.product.readyToOrder && response.product.productType !== 'bundle') || !response.product.available) {
            $('.js-addToCart', response.$productContainer).addClass('cc-disabled').attr('disabled', 'disabled');
            $('.js-addToCartSticky').addClass('cc-disabled').attr('disabled', 'disabled');
        } else {
            $('.js-addToCart', response.$productContainer).removeClass('cc-disabled').removeAttr('disabled');
            $('.js-addToCartSticky').removeClass('cc-disabled').removeAttr('disabled');
        }
    }

    $('.js-productDetail').attr('data-pid', response.product.id);
    $('.js-addToCart').attr('data-pid', response.product.id);
    $('.js-addToCartSticky').attr('data-pid', response.product.id);


    // Update attributes
    $productContainer.find('.js-mainAttributes').empty().html(getAttributesHtml(response.product.attributes));
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"'
                + selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger(
            'product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer }
        );

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);

                if (typeof data.product.regularDeliveryHtml === 'string') {
                    var $existingRD = $productContainer.find('.js-regularDelivery');
                    var savedDefaultValueId = $existingRD.attr('data-default-value-id');
                    var $checkedType = $existingRD.find('.js-purchaseType:checked');
                    var savedSelectedValueId = $checkedType.data('value-id') || null;
                    var savedIsRDSelected = !!(savedDefaultValueId && savedSelectedValueId && savedSelectedValueId !== savedDefaultValueId);

                    $productContainer.find('.js-regularDeliveryWrapper').html(data.product.regularDeliveryHtml);

                    var $newRD = $productContainer.find('.js-regularDelivery');
                    if (savedDefaultValueId) {
                        $newRD.attr('data-default-value-id', savedDefaultValueId);
                    }

                    if (savedIsRDSelected && savedSelectedValueId) {
                        var $rdRadio = $newRD.find('.js-purchaseType[data-value-id="' + savedSelectedValueId + '"]');
                        if ($rdRadio.length) {
                            $newRD.find('.js-purchaseType').prop('checked', false);
                            $rdRadio.prop('checked', true);
                        }
                    }
                }

                updateRegularDeliverySection(data.product, $productContainer, data.product.optionsHtml);

                var $rdFrequencySelect = $productContainer.find('.js-regularDelivery .js-rdFrequency');
                if ($rdFrequencySelect.length && $.fn.selectpicker) {
                    if ($rdFrequencySelect.siblings('.dropdown-toggle').length) {
                        $rdFrequencySelect.selectpicker('refresh');
                    } else {
                        $rdFrequencySelect.selectpicker();
                    }
                }

                updateQuantities(data.product.quantities, $productContainer);

                var currentQtyLabel = parseInt($productContainer.find('.js-qtyLabel').val()) || 1;
                $productContainer.find('.quantity-select').val(currentQtyLabel);

                $('body').trigger(
                    'product:afterAttributeSelect',
                    { data: data, container: $productContainer }
                );
                $.spinner().stop();
            },
            error: function () {
                $('body').trigger(
                    'product:attributeSelectError',
                    { container: $productContainer, url: selectedValueUrl }
                );
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.js-addToCartUrl').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        return;
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.js-productDetail');
            }

            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },

    selectAttribute: function () {
        $(document).on('click', '.js-variantsButton:not(.cc-pdp__product__variants__selected)', function (e) {
            e.preventDefault();
            const self = $(this);

            var $productContainer = self.closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = self.closest('.js-productDetail');
            }
            const $attributeSelected = self.data('url');
            attributeSelect($attributeSelected, $productContainer);
        });

        // select attribute value from dropdown for non-swatch attributes
        $(document).on('change', '.options-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.js-productDetail');
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        });
    },

    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.js-productDetail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                var selectedValueUrl = $(e.currentTarget).find('option:selected').data('url');
                var $rdContainer = $productContainer.find('.js-regularDelivery').first();
                if (selectedValueUrl && $rdContainer.length) {
                    var selectedValueId = $rdContainer.find('.js-purchaseType:checked').data('value-id');
                    var defaultValueId = $rdContainer.data('default-value-id');
                    var isRDSelected = selectedValueId && defaultValueId && selectedValueId !== defaultValueId;
                    selectedValueUrl = selectedValueUrl.replace(/[?&]showRDPrice=(true|false)/g, '');
                    selectedValueUrl += (selectedValueUrl.indexOf('?') === -1 ? '?' : '&') + 'showRDPrice=' + !!isRDSelected;
                }
                attributeSelect(
                    selectedValueUrl,
                    $productContainer
                );
            }
        });
    },

    addToCart: function () {
        $(document).on('click', 'button.js-addToCart, button.add-to-cart-global', function (e) {
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.js-productDetail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find('.product-id').text(),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            var $productContainer = $(this).closest('.js-productDetail');
            if (!$productContainer.length) {
                if ($(this).closest('.cc-stickyBar').length) {
                    $productContainer = $('.js-productDetail').first();
                } else {
                    $productContainer = $(this).closest('.quick-view-dialog').find('.js-productDetail');
                }
            }

            // Validate quantity before adding to cart
            var $quantityInput = $productContainer.find('.js-qtyLabel');
            var currentQuantity = parseInt($quantityInput.val());
            var quantityLimit = parseInt($quantityInput.attr('data-limit'));
            var addToCartCartQty = parseInt($quantityInput.attr('data-cart-qty')) || 0;
            var effectiveLimit = Math.max(quantityLimit - addToCartCartQty, 0);

            if (currentQuantity > effectiveLimit || currentQuantity <= 0 || isNaN(currentQuantity)) {
                $productContainer.find('.js-qtyLabelMsg').removeClass('d-none').addClass('d-block');
                $('.cc-stickyBar').find('.js-qtyLabelMsg').removeClass('d-none').addClass('d-block');
                return false;
            }

            addToCartUrl = getAddToCartUrl();

            var addedQty = currentQuantity;
            var $qtyInputRef = $quantityInput;
            var $hiddenQtySelect = $productContainer.find('.quantity-select');
            if ($hiddenQtySelect && $hiddenQtySelect.length) {
                $hiddenQtySelect.val(currentQuantity);
            }

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: currentQuantity
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.spinner().start();
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);

                        if (!data.error) {
                            var newCartQty = (parseInt($qtyInputRef.attr('data-cart-qty')) || 0) + addedQty;
                            var maxOrderQtyAfterAdd = parseInt($qtyInputRef.attr('data-limit'));
                            var newEffectiveLimit = Math.max(maxOrderQtyAfterAdd - newCartQty, 0);
                            var disabledClass = 'cc-pdp__product__qtyButton--disabled';

                            $('.js-qtyLabel, .js-stickyLabel')
                                .attr('data-cart-qty', newCartQty)
                                .val(1);

                            $productContainer.find('.quantity-select').val(1);

                            if (newEffectiveLimit <= 0) {
                                $('.js-plusQtyPdp, .js-stickyPlusQtyPdp').attr('disabled', 'disabled').addClass(disabledClass);
                                $('.js-minusQtyPdp, .js-stickyMinusQtyPdp').attr('disabled', 'disabled').addClass(disabledClass);
                                $('.js-addToCart, .js-addToCartSticky').attr('disabled', 'disabled');
                            } else {
                                $('.js-plusQtyPdp, .js-stickyPlusQtyPdp').removeAttr('disabled').removeClass(disabledClass);
                                $('.js-minusQtyPdp, .js-stickyMinusQtyPdp').attr('disabled', 'disabled').addClass(disabledClass);
                                $('.js-addToCart, .js-addToCartSticky').removeAttr('disabled');
                            }
                            var $mainImageItem = $productContainer.find('.cc-pdp__carousel__mainImage__item');
                            if (!$mainImageItem.length) {
                                $mainImageItem = $productContainer.find('.js-carouselMainImage').parent();
                            }

                            var prodImageHtml = $mainImageItem.html();
                            if (prodImageHtml) {
                                prodImageHtml = prodImageHtml.replace(/\/medium\//g, '/small/');
                                $('.js-prod-image').html(prodImageHtml);
                                $('.js-prod-image').find('img').attr('alt', '');
                            }

                            var productName = $productContainer.find('.cc-pdp__product__name').text();
                            $('.js-prod-name').text(productName);

                            var productPricesHtml = $productContainer.find('.cc-pdp__product__prices').html();
                            if (!productPricesHtml) {
                                productPricesHtml = $productContainer.find('.prices').html();
                            }
                            $('.js-prod-prices').html(productPricesHtml);
                            $('.js-prod-prices').find('[data-toggle="tooltip"]').tooltip({ html: true, container: 'body' });

                            var $ratingsRoot = $productContainer.find('.cc-pdp__product__ratings').first();
                            var ratingHtml = '';

                            if ($ratingsRoot.length) {
                                var $reviewHeader = $ratingsRoot.find('.review__header').first();
                                if ($reviewHeader.length) {
                                    ratingHtml = $reviewHeader[0].outerHTML;
                                } else {
                                    var $widgetWithTotal = $ratingsRoot.find('.skeepers_product__stars').filter(function () {
                                        return $(this).find('.stars__rating, .rate-total').length > 0;
                                    }).first();

                                    if ($widgetWithTotal.length) {
                                        ratingHtml = $widgetWithTotal[0].outerHTML;
                                    }
                                }
                            }

                            if (ratingHtml) {
                                $('.js-prod-rating').html(ratingHtml);
                            } else {
                                var $starsElement = $productContainer.find('.cc-pdp__product__ratings .stars');
                                if ($starsElement.length) {
                                    var starsHtml = '<div class="stars">' + $starsElement.html() + '</div>';
                                    $('.js-prod-rating').html(starsHtml);
                                } else {
                                    var productRatingHtml = $productContainer.find('.ratings').html();
                                    if (productRatingHtml) {
                                        $('.js-prod-rating').html(productRatingHtml);
                                    }
                                }
                            }

                            setTimeout(function () {
                                if ($('.js-prod-rating .rate-total').length) {
                                    return;
                                }

                                var $lateReviewHeader = $productContainer.find('.cc-pdp__product__ratings .review__header').first();
                                if ($lateReviewHeader.length) {
                                    $('.js-prod-rating').html($lateReviewHeader[0].outerHTML);
                                }
                            }, 10);

                            $('#addToCartProductModal').find('.js-suggested-tile-add-btn').removeClass('d-none');
                            $('#addToCartProductModal').find('.js-suggested-added').addClass('d-none');

                            var $suggestedContainer = $('#addToCartProductModal .js-suggested-products');
                            $suggestedContainer.empty();

                            $('#addToCartProductModal').modal('show');
                        } else {
                            // Handle error - show error toast with message
                            var $errorToast = $('.js-errorToast');
                            var errorMessage = data.message || data.errorMessage;

                            if (errorMessage) {
                                $errorToast.find('.cc-toast__text').text(errorMessage);
                            }

                            if ($('body').hasClass('modal-open')) {
                                $('body').find('.cc-modal.show').modal('hide');
                            }

                            var headerHeight = $('.cc-header').height() || 0;
                            $errorToast.css('top', headerHeight + 'px');
                            $errorToast.removeClass('d-none').addClass('show');

                            var scrollAnimateOffset = $errorToast.offset().top - headerHeight - 30;
                            $('html, body').animate({ scrollTop: scrollAnimateOffset }, 500);

                            setTimeout(function () {
                                $errorToast.removeClass('show').addClass('d-none');
                            }, 3000);
                        }

                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });

        $(document).on('click', '.js-addToCartSticky', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            var $mainAddBtn = $('.js-productDetail').first().find('.js-addToCart');
            if ($mainAddBtn.length) {
                $mainAddBtn.trigger('click');
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                    + '<div class="selected-pid row" '
                    + 'data-pid="' + pid + '"'
                    + 'data-qty="' + submittedQty + '"'
                    + 'data-optionID="' + (optionID || '') + '"'
                    + 'data-option-selected-value="' + (valueId || '') + '"'
                    + '>'
                    + '<div class="col-sm-11 col-9 bonus-product-name" >'
                    + $choiceOfBonusProduct.find('.product-name').html()
                    + '</div>'
                    + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                    + '</div>';
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr(
                'disabled',
                (!response.product.readyToOrder || !response.product.available)
            );
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption = parseInt($(this)
                    .data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        $('.minicart-quantity').html(data.totalQty);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    quantity: function () {
        // Initialize quantity button states on page load based on effective stock limit
        var $initQtyLabel = $('.js-qtyLabel');
        if ($initQtyLabel.length) {
            var initMaxOrderQty = parseInt($initQtyLabel.attr('data-limit'));
            var initCartQty = parseInt($initQtyLabel.attr('data-cart-qty')) || 0;
            var initEffectiveLimit = Math.max(initMaxOrderQty - initCartQty, 0);
            var initCurrentValue = parseInt($initQtyLabel.val()) || 1;
            var initDisabledClass = 'cc-pdp__product__qtyButton--disabled';

            $initQtyLabel.closest('.js-productDetail').find('.quantity-select').val(initCurrentValue);

            if (initCurrentValue <= 1 || initEffectiveLimit <= 0) {
                $('.js-minusQtyPdp, .js-stickyMinusQtyPdp').attr('disabled', 'disabled').addClass(initDisabledClass);
            } else {
                $('.js-minusQtyPdp, .js-stickyMinusQtyPdp').removeAttr('disabled').removeClass(initDisabledClass);
            }

            if (initCurrentValue >= initEffectiveLimit) {
                $('.js-plusQtyPdp, .js-stickyPlusQtyPdp').attr('disabled', 'disabled').addClass(initDisabledClass);
            } else {
                $('.js-plusQtyPdp, .js-stickyPlusQtyPdp').removeAttr('disabled').removeClass(initDisabledClass);
            }

            if (initEffectiveLimit <= 0) {
                $('.js-addToCart, .js-addToCartSticky').attr('disabled', 'disabled').addClass('cc-pdp__product__qtyButton--disabled');
                $('.cc-pdp__product__quantity, .cc-stickyBar__buttonsWrapper .cc-pdp__product__qtyButtonWrapper').addClass('d-none');
                $('.cc-pdp__product__addToCartButton__wrapper, .cc-stickyBar__addToCartButton__wrapper').addClass('d-none');
                $('.cc-pdp__product__addToCartButton__outOfStock').removeClass('d-none');
            }
        }

        $('body').on('click', '.js-minusQtyPdp, .js-plusQtyPdp', function (e) {
            e.stopImmediatePropagation();
            const $button = $(this);
            const $target = $button.closest('.cc-pdp__product__qtyButtonWrapper').find('.cc-pdp__product__qtyLabel');
            const $input = $button.closest('.cc-pdp__product__quantity').find('.quantity-select');
            const value = parseInt($target.val());
            const $stickyInput = $('.js-stickyLabel');
            const $stickyBar = $('.cc-stickyBar');
            const maxOrderQty = parseInt($target.attr('data-limit'));
            const cartQty = parseInt($target.attr('data-cart-qty')) || 0;
            let quantityLimit = Math.max(maxOrderQty - cartQty, 0);

            if ($button.data('action') === 'increase' && value < quantityLimit) {
                $target.val(value + 1);
                $input.val(value + 1);
                $stickyInput.val(value + 1);

                if (value + 1 !== quantityLimit) {
                    $('.cc-pdp__product__qtyButton[data-action="increase"]').removeAttr('disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                    $('.cc-pdp__product__qtyButton[data-action="decrease"]').removeAttr('disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                    $target.closest('.cc-pdp__container').find('.js-qtyLabelMsg').addClass('d-none').removeClass('d-block');
                    $target.closest('.cc-pdp__container').find('.js-addToCart').removeAttr('disabled');
                    $stickyBar.find('.js-qtyLabelMsg').addClass('d-none').removeClass('d-block');
                    $('.js-addToCartSticky').removeAttr('disabled');
                } else {
                    $('.cc-pdp__product__qtyButton[data-action="increase"]').attr('disabled', true).addClass('cc-pdp__product__qtyButton--disabled');
                    $('.cc-pdp__product__qtyButton[data-action="decrease"]').attr('disabled', false).removeClass('cc-pdp__product__qtyButton--disabled');
                }
            } else if ($button.data('action') === 'decrease' && value > 1) {
                $target.val(value - 1);
                $input.val(value - 1);
                $stickyInput.val(value - 1);

                 if (value - 1 <= quantityLimit) {
                    $('.cc-pdp__product__qtyButton[data-action="increase"]').removeAttr('disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                    $('.cc-pdp__product__qtyButton[data-action="decrease"]').removeAttr('disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                    $target.closest('.cc-pdp__container').find('.js-qtyLabelMsg').addClass('d-none').removeClass('d-block');
                    $target.closest('.cc-pdp__container').find('.js-addToCart').removeAttr('disabled');
                    $target.closest('.cc-pdp__product__addToCartWrapper').find('.js-qtyLabelMsg').addClass('d-none').removeClass('d-block');
                    $target.closest('.cc-pdp__product__addToCartWrapper').find('.js-addToCart').removeAttr('disabled', 'disabled');
                    $stickyBar.find('.js-qtyLabelMsg').addClass('d-none').removeClass('d-block');
                    $('.js-addToCartSticky').removeAttr('disabled');
                } 

                if (value - 1 !== 1) {
                    $('.cc-pdp__product__qtyButton[data-action="increase"]').removeAttr('disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                    $('.cc-pdp__product__qtyButton[data-action="decrease"]').removeAttr('disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                } else {
                    $('.cc-pdp__product__qtyButton[data-action="decrease"]').attr('disabled', true).addClass('cc-pdp__product__qtyButton--disabled');
                }

                if (value - 1 < quantityLimit) {
                    $('.cc-pdp__product__qtyButton[data-action="increase"]').removeAttr('disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                }
            }
            // DO NOT trigger change on quantity-select - it would call attributeSelect()
        });

        $('body').on('click', '.js-stickyMinusQtyPdp', function (e) {
            $('.js-minusQtyPdp').trigger('click');
        });

        $('body').on('click', '.js-stickyPlusQtyPdp', function (e) {
            $('.js-plusQtyPdp').trigger('click');
        });

        $('.js-qtyLabel, .js-stickyLabel').on('input', function (e) {
            e.preventDefault();
            const $self = $(this);
            let newValue = $self.val();
            const $productContainer = $self.closest('.js-productDetail');
            const $input = $productContainer.length > 0
                ? $productContainer.find('.quantity-select')
                : $(document).find('.quantity-select').first();
            const $stickyBarInput = $('.cc-stickyBar');

            var $otherInput = $('.js-stickyLabel');
            if ($self.hasClass('js-stickyLabel')) {
                $otherInput = $('.js-qtyLabel');
            }

            const maxOrderQty = parseInt($self.attr('data-limit'));
            const cartQty = parseInt($self.attr('data-cart-qty')) || 0;
            let quantityLimit = Math.max(maxOrderQty - cartQty, 0);

            if (newValue === '') {
                return;
            }

            if (!Number.isInteger(parseInt(newValue))) {
                $self.val($input.val());
                newValue = $input.val();
            } else if (!Number.isInteger(parseInt(newValue)) || parseInt(newValue) > quantityLimit || parseInt(newValue) === 0) {
                $self.closest('.cc-pdp__container').find('.js-qtyLabelMsg').removeClass('d-none').addClass('d-block');
                $self.closest('.cc-pdp__container').find('.js-addToCart').attr('disabled', 'disabled');
                $self.closest('.cc-pdp__product__addToCartWrapper').find('.js-qtyLabelMsg').removeClass('d-none').addClass('d-block');
                $self.closest('.cc-pdp__product__addToCartWrapper').find('.js-addToCart').attr('disabled', 'disabled');
                $stickyBarInput.find('.js-qtyLabelMsg').removeClass('d-none').addClass('d-block');
                $('.js-addToCartSticky').attr('disabled', 'disabled');
                $('.cc-pdp__product__qtyButton[data-action="increase"]').attr('disabled', 'disabled').addClass('cc-pdp__product__qtyButton--disabled');
                $('.cc-pdp__product__qtyButton[data-action="decrease"]').attr('disabled', 'disabled').addClass('cc-pdp__product__qtyButton--disabled');
                $otherInput.val(parseInt(newValue));
            } else {
                $self.val(parseInt(newValue));
                $otherInput.val(parseInt(newValue));
                $input.val(parseInt(newValue));

                $self.closest('.cc-pdp__container').find('.js-qtyLabelMsg').addClass('d-none').removeClass('d-block');
                $self.closest('.cc-pdp__container').find('.js-addToCart').removeAttr('disabled', 'disabled');
                $self.closest('.cc-pdp__product__addToCartWrapper').find('.js-qtyLabelMsg').addClass('d-none').removeClass('d-block');
                $self.closest('.cc-pdp__product__addToCartWrapper').find('.js-addToCart').removeAttr('disabled', 'disabled');
                $stickyBarInput.find('.js-qtyLabelMsg').addClass('d-none').removeClass('d-block');
                $('.js-addToCartSticky').removeAttr('disabled', 'disabled');
                if (parseInt(newValue) < quantityLimit) {
                    $('.js-plusQtyPdp, .js-stickyPlusQtyPdp').removeAttr('disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                } else {
                    $('.js-plusQtyPdp, .js-stickyPlusQtyPdp').attr('disabled', 'disabled').addClass('cc-pdp__product__qtyButton--disabled');
                }
            }

            if (parseInt(newValue) === 1) {
                $('.js-minusQtyPdp').attr('disabled', 'disabled').addClass('cc-pdp__product__qtyButton--disabled');
                $('.js-stickyMinusQtyPdp').attr('disabled', 'disabled').addClass('cc-pdp__product__qtyButton--disabled');
            } else {
                $('.js-minusQtyPdp').removeAttr('disabled', 'disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                $('.js-stickyMinusQtyPdp').removeAttr('disabled', 'disabled').removeClass('cc-pdp__product__qtyButton--disabled');
            }
        });

        $('.js-qtyLabel, .js-stickyLabel').on('focusout', function () {
            const $self = $(this);
            const value = $self.val();
            const $productContainer = $self.closest('.js-productDetail');
            const $quantitySelect = $productContainer.length > 0
                ? $productContainer.find('.quantity-select')
                : $(document).find('.quantity-select').first();
            const oldValue = $quantitySelect.val();
            const maxOrderQty = parseInt($self.attr('data-limit'));
            const cartQty = parseInt($self.attr('data-cart-qty')) || 0;
            const effectiveLimit = Math.max(maxOrderQty - cartQty, 0);

            var $otherInput = $('.js-stickyLabel');
            if ($self.hasClass('js-stickyLabel')) {
                $otherInput = $('.js-qtyLabel');
            }

            if (value === '') {
                $self.val(oldValue);
                $otherInput.val(oldValue);

                if (parseInt(oldValue) === 1) {
                    $('.js-minusQtyPdp').attr('disabled', 'disabled').addClass('cc-pdp__product__qtyButton--disabled');
                    $('.js-stickyMinusQtyPdp').attr('disabled', 'disabled').addClass('cc-pdp__product__qtyButton--disabled');
                } else {
                    $('.js-minusQtyPdp').removeAttr('disabled', 'disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                    $('.js-stickyMinusQtyPdp').removeAttr('disabled', 'disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                }

                if (parseInt(oldValue) >= effectiveLimit) {
                    $('.js-plusQtyPdp, .js-stickyPlusQtyPdp').attr('disabled', 'disabled').addClass('cc-pdp__product__qtyButton--disabled');
                } else {
                    $('.js-plusQtyPdp, .js-stickyPlusQtyPdp').removeAttr('disabled').removeClass('cc-pdp__product__qtyButton--disabled');
                }
            }
        });
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl
};
